/** @format */

import { useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  add_To_card,
  add_To_wishlist,
  messageClear,
} from "../../store/reducers/cardReducers";
import { add_friend, send_message } from "../../store/reducers/chatReducer";
import ProductCard from "./ProductCard";

const ShopProducts = ({ styles, products }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { customerInfo } = useSelector((state) => state.auth);
  const { successMessage, messageError } = useSelector((state) => state.card);

  const add_card = (id) => {
    if (customerInfo) {
      dispatch(
        add_To_card({
          customerId: customerInfo.id,
          productId: id,
          quantity: 1,
        }),
      );
    } else {
      navigate("/login");
    }
  };

  const add_wishlist = (product) => {
    if (customerInfo) {
      dispatch(
        add_To_wishlist({
          customerId: customerInfo.id,
          productId: product._id,
          name: product.name,
          price: product.price,
          image: product.images[0],
          discount: product.discount,
          rating: product.rating,
          slug: product.slug,
        }),
      );
    }
  };

  const sendProductInfoMessage = async (product) => {
    if (!customerInfo) return navigate("/login");
    const finalPrice = product.discount
      ? Math.floor((parseFloat(product.price) * (100 - product.discount)) / 100)
      : product.price;
    const payload = {
      senderName: customerInfo.name,
      customerId: customerInfo.id,
      sellerId: product.sellerId,
      messageType: "product",
      message: "",
      productInfo: {
        image: product.images[0].url || product.images[0],
        title: product.name,
        price: finalPrice,
        stock: product.stock,
        productId: product._id,
      },
    };
    await dispatch(
      add_friend({
        sellerId: product.sellerId || "",
        customerId: customerInfo.id,
      }),
    );
    dispatch({ type: "chat/updateFdMessages", payload });
    dispatch(send_message(payload))
      .unwrap()
      .then(() => {
        toast.success("Message envoyé au vendeur !");
        navigate(`/dashboard/my_chats/${product.sellerId}`);
      })
      .catch((err) => {
        toast.error("Erreur lors de l'envoi du message");
        console.error(err);
      });
  };

  useEffect(() => {
    if (messageError) dispatch(messageClear());
    if (successMessage) dispatch(messageClear());
  }, [messageError, successMessage, dispatch]);

  return (
    <div
      className={`w-full grid ${
        styles === "grid"
          ? "grid-cols-4 md-lg:grid-cols-2 md:grid-cols-1"
          : "grid-cols-2 md-lg:grid-cols-2 md:grid-cols-1"
      } gap-3`}
    >
      {products.map((product, i) => (
        <ProductCard
          key={product._id || i}
          product={product}
          customerInfo={customerInfo}
          onAddCard={add_card}
          onAddWishlist={add_wishlist}
          onSendMessage={sendProductInfoMessage}
        />
      ))}
    </div>
  );
};

export default ShopProducts;
